module.exports = __webpack_public_path__ + "media/img/illustrations/icons/close-ef83b9ee3625e513a75b87b44b7fff77.svg";